import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=43349301&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "./platform.vue?vue&type=style&index=0&id=43349301&scoped=true&lang=scss"
import style1 from "./platform.vue?vue&type=style&index=1&id=43349301&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43349301",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43349301')) {
      api.createRecord('43349301', component.options)
    } else {
      api.reload('43349301', component.options)
    }
    module.hot.accept("./platform.vue?vue&type=template&id=43349301&scoped=true", function () {
      api.rerender('43349301', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/configure/platform.vue"
export default component.exports